import {Injectable} from '@angular/core';
import {ResourceService} from '~/app/core/common/services/ResourceService';
import {OrderSerializer} from '~/app/core/common/serializers/OrderSerializer';
import {Order} from '~/app/core/common/models/Order';
import {OrderItemInsert} from '~/app/core/common/models/orderItemInsert';
import {ConfigurationService} from '~/app/core/common/services/configuration.service';
import {BaseService} from '~/app/core/common/services/base.service';
import {ApiService} from '~/app/core/common/services/api.service';
import { catchError, map } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})
export class OrderService extends ResourceService<Order> {

    constructor(public baseService: BaseService,
                public apiService: ApiService,
                private configuration: ConfigurationService,
    ) {

        super(baseService,
            '',
            '',
            new OrderSerializer());
    }

    public createUnscheduledOrder(storeNumber: string) {
        return this.baseService.getHttpObject<string>(
            'createUnscheduledOrder',
            'order-service',
            this.apiService.orderCreateURL + storeNumber)
            .pipe(map((data: any) => data));
    }

    public insertItemsIntoOrder(itemsToInsert: OrderItemInsert) {
        const jsonOrder = JSON.stringify(itemsToInsert);
        return this.baseService.postHttpJson(
            'insertItemsIntoOrder',
            'order-service',
            this.apiService.orderInsertItemURL,
            jsonOrder)
            .pipe(catchError(this.handleError));
    }

    public setStatusOrder(trackingId: string, status: number, custId: string) {
        return this.baseService.putHttp(
            'setStatusOrder',
            'order-service',
            this.apiService.orderStatusUpdateURL
                .replace('order_number', trackingId)
                .replace('status_status', status.toString())
                .replace('cust_id', custId))
            .pipe(catchError(this.handleError));
    }

    public createScheduledOrder(trackingId: string, custId: number) {
        return this.baseService.getHttp(
            'createScheduledOrder',
            'order-service',
            this.apiService.orderCreateSchedURL + custId + '/' + trackingId)
            .pipe(catchError(this.handleError))
            .pipe(map((data: any) => data));
    }

    public checkOpenOrder(custId: number) {
        return this.baseService.getHttp(
            'checkOpenOrder',
            'order-service',
            this.apiService.orderOpenoOrder + custId)
            .pipe(catchError(this.handleError))
            .pipe(map((data: any) => data));
    }
}
